import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { FormattedMessage, injectIntl } from 'react-intl'
import Title from '../../layout/Title/Title'
import appConfig from '../../../config'
import { fillLeadingZeros } from '../../../utils/idUtil'
import { CopyLink } from '../../misc'

@injectIntl
class InviteParticipantsModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    modal: PropTypes.func,
    orgId: PropTypes.number,
    alId: PropTypes.number
  }

  render () {
    const {
      modalId,
      modal,
      orgId,
      alId
    } = this.props

    const globalAuId =  orgId && fillLeadingZeros(orgId, 8, 'AU')
    const auLink = `${appConfig.foUrl}/register/participant/welcome/${globalAuId}`
    const globalAlId =  alId && fillLeadingZeros(alId, 8,'AL')
    const alLink = `${appConfig.foUrl}/register/participant/welcome/${globalAlId}`

    return (
      <Modal id={modalId} modal={modal}>
        <div className="row">
          <div className="col-xs-12" style={{ marginBottom: '15px'}}>
            <Title h2 intlKey="moduleTitle.invite_participants"  style={{ textAlign: 'center', color: '#4e4e4e' }}>
              Invite participants
            </Title>
            <div>
              <FormattedMessage
                id="label.invite_participants_desc"
                defaultMessage="Make the participant registrations easier by sharing the following addresses. Using this address the participant does not need to fill in the award centre name
                or they can be even directly assigned to you." />
            </div>
            <br />
            <div>
              <FormattedMessage
                id="label.invite_participants_award_centre_desc"
                defaultMessage="Use this for your Award Centre." />
              <CopyLink text={auLink} showText={true}/>

            </div>
            <br />
            <div>
              <FormattedMessage
                id="label.invite_participants_award_leader_desc"
                defaultMessage="Use this to assign participant directly to you." />
              <CopyLink text={alLink} showText={true}/>
            </div>

          </div>
        </div>
      </Modal>
    )
  }
}

export default InviteParticipantsModal
